const FULFILLMENT_STATUS_LABELS: Record<string, string> = {
  fulfilled: 'Completada',
  pending: 'Pendiente',
  canceled: 'Cancelada',
  cancelled: 'Cancelada',
  processing: 'En proceso',
  shipped: 'Enviada',
};

export const formatFulfillmentStatus = (status?: string): string => {
  if (!status?.trim()) {
    return '—';
  }

  return FULFILLMENT_STATUS_LABELS[status.toLowerCase()] ?? status;
};
